import vars from '../helpers';
import {TweenMax, Sine} from 'gsap';
import Preloader from 'ninelines-preloader';

const MIN_LOAD_TIME_MS = 2000;

const $preloader = $('.preloader');


let preloader = (callback) => {
	let images = [];

	$('.index__item').each((index, item) => {
		images.push($(item).css('background-image').slice(4, -1).replace(/"/g, ""));
	});

	Preloader.init(images, MIN_LOAD_TIME_MS)
		.then(() => {
			TweenMax.to($preloader, 0.5, {
				autoAlpha: 0,
				onStart() {
					vars.$header.removeClass('is-hidden');
					vars.$footer.removeClass('is-hidden');
					if (callback) {
						callback();
					}
				},
				onComplete() {
					$preloader.hide();
				},
			});
		});
};

export default preloader;
